import React, { ReactNode } from 'react';

import { ReactComponent as ActiveIcon } from 'assets/icons/ic_active.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/ic_close.svg';
import AbsoluteModal from 'components/modal/AbsoluteModal';

type Props = {
  width: string;
  subWidth: string;
  title: string;
  onDeleteAll?: () => void;
  isActive: boolean;
  setActive: () => void;
  onClose: () => void;
  modalContent?: ReactNode;
  hideClose?: boolean;
  closePosition?: string;
  position?: string;
  ignoreRefs?: React.RefObject<HTMLDivElement | HTMLSpanElement>[];
  inputReadOnly?: boolean;
  contentMaxHeightClassName?: string;
  hideAbsoluteModal?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const SearchWrapper = ({
  width,
  subWidth,
  title,
  onDeleteAll,
  isActive,
  setActive,
  onClose,
  modalContent,
  hideClose,
  closePosition,
  position = 'left-0',
  ignoreRefs,
  inputReadOnly,
  contentMaxHeightClassName = 'max-h-[420px]',
  hideAbsoluteModal,
  ...props
}: Props) => {
  return (
    <div className={`flex h-full cursor-pointer items-center md:relative ${width}`}>
      <div
        className="flex h-full w-full flex-col justify-center gap-y-1.5"
        onClick={() => (isActive ? onClose() : setActive())}
      >
        <div className="flex items-center gap-x-1.5">
          <span className="truncate text-[11px] font-semibold leading-[1.4] tracking-[-0.022em] md:text-c2">
            {title}
          </span>
          {isActive && <ActiveIcon width={20} height={20} />}
        </div>
        <div className="flex max-w-full items-center gap-x-1 overflow-hidden">
          <input
            className="grow text-ellipsis border-0 text-[12px] outline-none placeholder:text-gray-40 md:text-c2"
            {...props}
            onClick={(e) => isActive && e.stopPropagation()}
            readOnly={inputReadOnly}
          />
          {onDeleteAll && isActive && props.value && (
            <button
              className="rounded-full bg-[#727272] text-white opacity-50"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteAll();
              }}
            >
              <CloseIcon width={12} height={12} />
            </button>
          )}
        </div>
      </div>
      {isActive && !hideAbsoluteModal && (
        <AbsoluteModal
          width={subWidth}
          position={`top-[100px] ${position}`}
          onClose={onClose}
          hideClose={hideClose}
          clickOutside
          closePosition={closePosition}
          ignoreRefs={ignoreRefs}
        >
          <div className={`${contentMaxHeightClassName} overflow-y-auto`}>{modalContent}</div>
        </AbsoluteModal>
      )}
    </div>
  );
};

export default SearchWrapper;
